import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { decodeCopyPayload } from "./markdown-highlight.ts";
import { toSanitizedMarkdownHtml } from "./markdown.ts";

export function handleMarkdownContainerClick(e: Event): void {
  const target = e.target;
  if (!(target instanceof HTMLElement)) {
    return;
  }
  const btn = target.closest(".chat-code-block-wrap__copy");
  if (!(btn instanceof HTMLButtonElement)) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  const wrap = btn.closest(".chat-code-block-wrap");
  const encoded = wrap?.getAttribute("data-raw") ?? "";
  const text = decodeCopyPayload(encoded);
  if (!text) {
    return;
  }
  void navigator.clipboard.writeText(text).then(() => {
    const prev = btn.textContent;
    btn.textContent = "Copied";
    window.setTimeout(() => {
      btn.textContent = prev ?? "Copy";
    }, 1500);
  });
}

/** Render assistant/user markdown with syntax-highlighted fenced code and copy buttons. */
export function renderMarkdownContent(markdown: string) {
  const sanitized = toSanitizedMarkdownHtml(markdown);
  return html`
    <div class="chat-markdown" @click=${handleMarkdownContainerClick}>
      ${unsafeHTML(sanitized)}
    </div>
  `;
}
